import Raven from "raven-js";
import axios from "axios";

import {
  LOGIN_USER_START,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  CHANGE_DATA,
  CHANGE_STEP,
  REGISTRATION_CONFIRMED,
  REGISTRATION_SAVING,
  REGISTRATION_SAVED,
  REGISTRATION_ERROR,
  ADD_AFFILIATE,
  ADD_REFERER,
  SET_AUTHTOKEN,
  FETCH_USER_START,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  USER_SIGNOUT,
  //ORDER_TOKEN,
  ORDER_TOKEN_SAVE,
  ORDER_TOKEN_START,
  ORDER_TOKEN_SUCCESS,
  ORDER_TOKEN_FAILURE,
  ADMIN_SEARCH_USER_START,
  ADMIN_SEARCH_USER_SUCCESS,
  ADMIN_SEARCH_USER_FAILURE,
  ADMIN_LOAD_ID_START,
  ADMIN_LOAD_ID_SUCCESS,
  ADMIN_LOAD_ID_FAILURE,
  LOAD_ID_START,
  LOAD_ID_SUCCESS,
  LOAD_ID_FAILURE,
  REG_EDIT_START,
  REG_EDIT_SUCCESS,
  REG_EDIT_FAILURE,
  SET_SS,
  FETCH_CONVERSION_START,
  FETCH_CONVERSION_SUCCESS,
  FETCH_CONVERSION_FAILURE,
  FETCH_ORDERS_START,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  SAVE_PAYMENT_START,
  SAVE_PAYMENT_SUCCESS,
  SAVE_PAYMENT_FAILURE,
  REQ_BACKUP_START,
  REQ_BACKUP_SUCCESS,
  REQ_BACKUP_FAILURE
} from "../constants/action-types";

import postRegistration from "../lib/store";

export function loginUser(email, redirect) {
  return (dispatch, getState) => {
    dispatch(loginUserStart(email, redirect));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";

    return axios({
      url: "/p/user/login",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {},
      data: { email, redirect }
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(loginUserSuccess());
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("Login failed " + JSON.stringify(result));
          dispatch(loginUserFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(loginUserFailure(error));
      }
    );
  };
}
export const setSalesState = state => ({
  type: SET_SS,
  payload: state
});
export const loginUserStart = (email, redirect) => ({
  type: LOGIN_USER_START,
  payload: { email, redirect }
});
export const loginUserSuccess = () => ({
  type: LOGIN_USER_SUCCESS
});

export const loginUserFailure = error => ({
  type: LOGIN_USER_FAILURE,
  payload: error
});

export const addReferer = referer => ({
  type: ADD_REFERER,
  payload: referer
});
export const addAffiliate = affiliate => ({
  type: ADD_AFFILIATE,
  payload: affiliate
});

export const changeData = (section, data) => ({
  type: CHANGE_DATA,
  payload: { section, data }
});
export const changeStep = step => ({ type: CHANGE_STEP, payload: step });
export const registrationConfirmed = () => ({ type: REGISTRATION_CONFIRMED });
export const saveRegistration = part => {
  return function(dispatch, getState) {
    const state = getState();
    if (state.document.document_type === "Passport" && part === "backside") {
      return;
    }
    dispatch(registrationSaving(part));
    return postRegistration(state, part).then(
      result => {
        if (
          result.status === 200 &&
          result.data.message &&
          result.data.message === "stored"
        ) {
          dispatch(registrationSaved(part));
        } else {
          // window.console && console.log(result);
          Raven.captureMessage(
            "postRegistration failed " + JSON.stringify(result)
          );

          dispatch(
            registrationError(part, {
              display: {
                status: result.status,
                msg: result.data
              },
              error: result
            })
          );
        }
      },
      error => {
        Raven.captureException(error);

        dispatch(
          registrationError(part, {
            display: { status: "", msg: error.message },
            error: error
          })
        );
      }
    );
  };
};

export const setAuthToken = token => ({ type: SET_AUTHTOKEN, payload: token });
export const userSignout = () => ({ type: USER_SIGNOUT });
export const registrationSaving = part => ({
  type: REGISTRATION_SAVING,
  payload: part
});
export const registrationSaved = part => ({
  type: REGISTRATION_SAVED,
  payload: part
});
export const registrationError = (part, error) => ({
  type: REGISTRATION_ERROR,
  payload: { part, error }
});
export const fetchUserStart = () => ({ type: FETCH_USER_START });
export const fetchUserSuccess = data => ({
  type: FETCH_USER_SUCCESS,
  payload: data
});
export const fetchUserFailure = error => ({
  type: FETCH_USER_FAILURE,
  payload: error
});
export function fetchUser(callbackForRetriggering) {
  return (dispatch, getState) => {
    dispatch(fetchUserStart());
    const authToken = getState().auth.token;

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";

    return axios({
      url: "/p/user",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      }
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(fetchUserSuccess(result));

          if (
            (callbackForRetriggering &&
              result.data.status === "emailVerified") ||
            result.data.status === "kycREVIEW"
          ) {
            callbackForRetriggering(); //callback for calling again
          }
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("getUser failed " + JSON.stringify(result));
          dispatch(fetchUserFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(fetchUserFailure(error));
      }
    );
  };
}
export const orderTokenSave = investement => ({
  type: ORDER_TOKEN_SAVE,
  payload: investement
});
export const orderTokenStart = () => ({ type: ORDER_TOKEN_START });
export const orderTokenSuccess = data => ({
  type: ORDER_TOKEN_SUCCESS,
  payload: data
});
export const orderTokenFailure = error => ({
  type: ORDER_TOKEN_FAILURE,
  payload: error
});

export function orderToken(order) {
  return (dispatch, getState) => {
    dispatch(orderTokenSave(order));
    dispatch(orderTokenStart());
    const authToken = getState().auth.token;

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";

    return axios({
      url: "/p/ordertoken",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      },
      data: { order: order }
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(orderTokenSuccess(result.data.orders));
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("getUser failed " + JSON.stringify(result));
          dispatch(orderTokenFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(orderTokenFailure(error));
      }
    );
  };
}

export function adminSearchUser(searchtext) {
  return (dispatch, getState) => {
    dispatch(adminSearchUserStart(searchtext));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;
    return axios({
      url: "/p/admin/user/search",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      },
      data: { searchtext }
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(adminSearchUserSuccess(result.data.data));
        } else {
          // window.console && console.log(result);
          if (result.status !== 201) {
            Raven.captureMessage(
              "adminSearchUser failed " + JSON.stringify(result)
            );
          }
          dispatch(adminSearchUserFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(adminSearchUserFailure(error));
      }
    );
  };
}
export const adminSearchUserStart = searchtext => ({
  type: ADMIN_SEARCH_USER_START,
  payload: searchtext
});
export const adminSearchUserSuccess = result => ({
  type: ADMIN_SEARCH_USER_SUCCESS,
  payload: result
});

export const adminSearchUserFailure = error => ({
  type: ADMIN_SEARCH_USER_FAILURE,
  payload: error
});

export function adminLoadID(userid) {
  return (dispatch, getState) => {
    dispatch(adminLoadIDStart(userid));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;

    const getImage = Part => {
      return axios({
        url: "/p/user/loadid",
        method: "post",
        baseURL: baseURLapi,
        crossdomain: true,
        headers: {
          Authorization: "Bearer " + authToken
        },
        data: { UserID: userid, Part }
      });
    };
    const transfers = [
      getImage("frontside"),
      getImage("backside"),
      getImage("selfi")
    ];

    Promise.all(transfers).then(
      result => {
        if (result[0].status === 200) {
          result.map(r => {
            if (r.data.data.Image !== null)
              dispatch(adminLoadIDSuccess(r.data.data));
            return null;
          });
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("Login failed " + JSON.stringify(result));
          dispatch(adminLoadIDFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(adminLoadIDFailure(error));
      }
    );
  };
}
export const adminLoadIDStart = userid => ({
  type: ADMIN_LOAD_ID_START,
  payload: userid
});
export const adminLoadIDSuccess = result => ({
  type: ADMIN_LOAD_ID_SUCCESS,
  payload: result
});

export const adminLoadIDFailure = error => ({
  type: ADMIN_LOAD_ID_FAILURE,
  payload: error
});

export function LoadID(userid) {
  return (dispatch, getState) => {
    dispatch(LoadIDStart(userid));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;

    const getImage = Part => {
      return axios({
        url: "/p/user/loadid",
        method: "post",
        baseURL: baseURLapi,
        crossdomain: true,
        headers: {
          Authorization: "Bearer " + authToken
        },
        data: { UserID: userid, Part }
      });
    };
    const transfers = [
      getImage("frontside"),
      getImage("backside"),
      getImage("selfi")
    ];

    Promise.all(transfers).then(
      result => {
        if (result[0].status === 200) {
          result.map(r => {
            if (r.data.data.Image !== null)
              dispatch(LoadIDSuccess(r.data.data));
            return null;
          });
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("Login failed " + JSON.stringify(result));
          dispatch(LoadIDFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(LoadIDFailure(error));
      }
    );
  };
}
export const LoadIDStart = userid => ({
  type: LOAD_ID_START,
  payload: userid
});
export const LoadIDSuccess = result => ({
  type: LOAD_ID_SUCCESS,
  payload: result
});

export const LoadIDFailure = error => ({
  type: LOAD_ID_FAILURE,
  payload: error
});

export const RegEditStart = () => ({ type: REG_EDIT_START });

export const RegEditSuccess = data => ({
  type: REG_EDIT_SUCCESS,
  payload: data
});
export const RegEditFailure = error => ({
  type: REG_EDIT_FAILURE,
  payload: error
});

export function RegEditSave() {
  return (dispatch, getState) => {
    dispatch(RegEditStart());
    const authToken = getState().auth.token;

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const state = getState();
    const data = {
      User: {
        Identity: {
          DateOfBirth: state.personal_information.birthdate,
          LastName: state.personal_information.full_last_name,
          FirstName: state.personal_information.full_first_name,
          Nationality: state.personal_information.nationality
        },
        Address: {
          ZIP: state.personal_information.zip,
          Street: state.personal_information.street_address,
          Country: state.personal_information.country,
          City: state.personal_information.city
        },
        Email: state.personal_information.email,
        IdentityDocuments: {
          Type: state.document.document_type,
          ID: state.document.document_id
          // frontside:state.document.document_images.frontside,
          // backside:state.document.document_images.backside,
          // selfi:state.document.document_images.selfi,
        }
      }
    };

    const send = part => {
      return axios({
        url: "/p/user/save",
        method: "post",
        baseURL: baseURLapi,
        crossdomain: true,
        headers: {
          Authorization: "Bearer " + authToken
        },
        data: {
          ...data,
          User: {
            ...data.User,
            IdentityDocuments: {
              ...data.User.IdentityDocuments
              //[part]: state.document.document_images[part]
            }
          },
          document: {
            [part]: state.document.document_images[part]
          }
        }
      });
    };

    let transfers = [send("frontside"), send("selfi")];
    if (state.document.document_type === "ID Card")
      transfers.push(send("backside"));
    Promise.all(transfers).then(
      result => {
        if (result[0].status === 200) {
          dispatch(RegEditSuccess());
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("RegEdit save failed " + JSON.stringify(result));
          dispatch(RegEditFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(RegEditFailure(error));
      }
    );
  };
}

export function getConversion() {
  return (dispatch, getState) => {
    dispatch(getConversionStart());

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    return new Promise(resolve => {
      axios({
        url: "/p/conversion",
        method: "get",
        baseURL: baseURLapi,
        crossdomain: true
      }).then(
        result => {
          if (result.status === 200) {
            dispatch(getConversionSuccess(result.data));
          } else {
            // window.console && console.log(result);
            Raven.captureMessage(
              "getConversion failed " + JSON.stringify(result)
            );
            dispatch(getConversionFailure(result));
          }

          resolve(result);
        },
        error => {
          Raven.captureException(error);
          dispatch(getConversionFailure(error));
        }
      );
    });
  };
}
export const getConversionStart = searchtext => ({
  type: FETCH_CONVERSION_START,
  payload: searchtext
});
export const getConversionSuccess = result => ({
  type: FETCH_CONVERSION_SUCCESS,
  payload: result
});

export const getConversionFailure = error => ({
  type: FETCH_CONVERSION_FAILURE,
  payload: error
});

export function getOrders() {
  return (dispatch, getState) => {
    dispatch(getOrdersStart());
    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;

    return axios({
      url: "/p/orders/all",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      },
      data: {}
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(getOrdersSuccess(result.data));
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("getOrders failed " + JSON.stringify(result));
          dispatch(getOrdersFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(getOrdersFailure(error));
      }
    );
  };
}
export const getOrdersStart = searchtext => ({
  type: FETCH_ORDERS_START,
  payload: searchtext
});
export const getOrdersSuccess = result => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: result
});

export const getOrdersFailure = error => ({
  type: FETCH_ORDERS_FAILURE,
  payload: error
});

export function savePayment(payment) {
  return (dispatch, getState) => {
    dispatch(savePaymentStart(payment));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;
    return axios({
      url: "/p/order/pay",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      },
      data: payment
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(savePaymentSuccess(result.data.data));
        } else {
          // window.console && console.log(result);
          Raven.captureMessage("savePayment failed " + JSON.stringify(result));
          dispatch(savePaymentFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(savePaymentFailure(error));
      }
    );
  };
}
export const savePaymentStart = payment => ({
  type: SAVE_PAYMENT_START,
  payload: payment
});
export const savePaymentSuccess = result => ({
  type: SAVE_PAYMENT_SUCCESS,
  payload: result
});

export const savePaymentFailure = error => ({
  type: SAVE_PAYMENT_FAILURE,
  payload: error
});

export const requestBackup = config => {
  return (dispatch, getState) => {
    dispatch(requestBackupStart(config));

    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";
    const authToken = getState().auth.token;
    return axios({
      url: "/p/q/backup",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      headers: {
        Authorization: "Bearer " + authToken
      },
      data: config
    }).then(
      result => {
        if (result.status === 200) {
          dispatch(requestBackupSuccess(result.data.data));
        } else {
          // window.console && console.log(result);
          Raven.captureMessage(
            "requestBackup failed " + JSON.stringify(result)
          );
          dispatch(requestBackupFailure(result));
        }
      },
      error => {
        Raven.captureException(error);
        dispatch(requestBackupFailure(error));
      }
    );
  };
};
export const requestBackupStart = config => ({
  type: REQ_BACKUP_START,
  payload: config
});
export const requestBackupSuccess = result => ({
  type: REQ_BACKUP_SUCCESS,
  payload: result
});

export const requestBackupFailure = error => ({
  type: REQ_BACKUP_FAILURE,
  payload: error
});
